import React from "react";
import AgentTeamsCard from "./AgentTeamsCard";

/**
 * The Agent Teams component.
 * @param {array} teamInfo - The array of an agent's team member info data.
 * @returns The Team section of an agent page.
 */
const AgentTeams = ({ teamInfo }) => {
    if (!teamInfo) return null;

    return (
        <div className="mt-3 gap-5" style={{ columnWidth: "300px" }}>
            {Array.isArray(teamInfo) &&
                teamInfo.map((member) => (
                    <AgentTeamsCard member={member} key={member?.agentUri} />
                ))}
        </div>
    );
};

export default AgentTeams;
